
async function updateCustomerMetafield({
  customerId,
  key,
  value,
  type,
  namespace = "custom"
}) {
  if (!customerId || !key || value === undefined) {
    throw new Error("customerId, key, and value are required");
  }

  const token = getStoredAgchimpToken();
  if (!token) {
    throw new Error("AgChimp token missing");
  }

  const customerGid =
    typeof customerId === "string" && customerId.startsWith("gid://")
      ? customerId
      : `gid://shopify/Customer/${String(customerId)}`;

  const query = `
    mutation UpdateCustomerMetafield($input: CustomerInput!) {
      customerUpdate(input: $input) {
        customer {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: {
      id: customerGid,
      metafields: [
        {
          namespace,
          key,
          type,
          value: String(value)
        }
      ]
    }
  };
console.log(variables)
  const response = await fetch(
    "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
      body: JSON.stringify({ query, variables })
    }
  );

  const result = await response.json();

  if (result.errors || result.data.customerUpdate.userErrors.length) {
    console.error("Metafield update failed:", result);
    throw new Error("Customer metafield update failed");
  }

  return result.data.customerUpdate.customer;
}
